import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import LoginForm from './LoginForm';
import LoginFormWidget from './LoginFormWidget';
import config from '../config/okta.config';

import { withAuth } from '@okta/okta-react';

export default withAuth(class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { authenticated: null };
    this.checkAuthentication = this.checkAuthentication.bind(this);
    this.checkAuthentication();
  }

  async checkAuthentication() {
    const authenticated = await this.props.auth.isAuthenticated();
    if (authenticated !== this.state.authenticated) {
      this.setState({ authenticated });
    }
  }

  componentDidUpdate() {
    this.checkAuthentication();
  }

  render() {
    if (this.state.authenticated === null) return null;
    return this.state.authenticated ?
      <Redirect to={{ pathname: '/' }}/> :
      // <LoginFormWidget baseUrl={this.props.baseUrl} />;
      (window.location.hostname != '10.83.235.101')?
      <LoginFormWidget baseUrl={this.props.baseUrl} />:
      <LoginForm baseUrl={this.props.baseUrl} />
  }
});
